"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneInboundIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const PhoneInboundIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.929 16.023c-.175.175-.405.234-.667.208-.946-.093-2.325-1.288-3.157-2.12-.683-.682-1.756-1.95-2.034-2.898-.111-.38-.096-.706.123-.925.63-.63.844-.844.917-1.1.038-.132.038-.275.038-.493 0-.51-.424-1.912-.637-2.549-.148-.444-.438-.637-.637-.637H5.326c-.212 0-.637.128-.637.637 0 .032 0 .072-.002.12-.013.677-.057 2.952 1.552 5.775.603 1.056 1.437 2.19 2.592 3.345a14.935 14.935 0 0 0 3.77 2.758c2.328 1.187 4.429 1.453 5.47 1.384.212 0 .637-.128.637-.637v-2.55c0-.212-.198-.478-.637-.637-.236-.084-.702-.188-1.19-.298-.506-.112-1.035-.23-1.36-.339-.477-.159-.846.21-1.592.956Zm5.708 5a2.71 2.71 0 0 1-1.48.503c-2.154.127-6.768-.754-10.74-4.726-2.48-2.479-3.685-4.93-4.253-6.918a12.384 12.384 0 0 1-.45-2.505 11.427 11.427 0 0 1-.027-1.108l.002-.088V6.146c0-.906.423-1.666 1.07-2.133a2.71 2.71 0 0 1 1.567-.504h2.55c1.38 0 2.231 1.097 2.534 2.005.115.347.287.895.432 1.435.118.44.307 1.18.307 1.746v.058c.004.287.01.957-.404 1.648-.17.283-.375.516-.533.686.343.558.894 1.197 1.308 1.61.475.475 1.074 1.006 1.588 1.334.19-.174.394-.345.599-.483.572-.386 1.433-.716 2.447-.378.198.066.595.158 1.137.279l.102.023c.416.092.994.22 1.355.35.788.284 1.96 1.073 1.96 2.52v2.549c0 .906-.423 1.666-1.07 2.132Zm-1.85-15.957-1.356 1.356H21.5a.8.8 0 1 1 0 1.6h-5.069l1.357 1.357a.8.8 0 0 1-1.131 1.131l-2.72-2.72a.796.796 0 0 1-.002-1.133l2.722-2.723a.8.8 0 0 1 1.13 1.132Z"
}));
exports.PhoneInboundIcon = PhoneInboundIcon;